import {
  Injectable,
  SecurityContext,
  inject,
  EnvironmentInjector,
  runInInjectionContext,
} from "@angular/core";
import { Database, ref, push, remove } from "@angular/fire/database";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable()
export class EmailService {
  private readonly mdb = inject(Database);
  private readonly injector = inject(EnvironmentInjector);
  constructor(private sanitizer: DomSanitizer) {}

  addEmail(subject: string, body: string, to: string, from: string) {
    runInInjectionContext(this.injector, () =>
      push(ref(this.mdb, "emails"), {
        subject: this.sanitizer.sanitize(SecurityContext.HTML, subject),
        body: this.sanitizer.sanitize(SecurityContext.HTML, body),
        to: to,
        from: from,
      })
    );
  }

  clearEmailQueue() {
    runInInjectionContext(this.injector, () =>
      remove(ref(this.mdb, "emails"))
    );
  }
}
